import { MarkerTransportationSection } from 'components/minute/sidebar/MarkerSidebar/DirectionMarkerSidebar/MarkerTransportationSection';
import { DirectionRouteMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/shared/DirectionRouteMarkerStyleSection';
import { MarkerControlsSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerControlsSection';
import { MarkerCoordinatesSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerCoordinatesSection';
import { MarkerFloorSection } from 'components/minute/sidebar/MarkerSidebar/shared/MarkerFloorSection';
import { useContext } from 'react';
import { IDirectionWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { getTransportPath } from 'static/externalApi/directionApi';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IDirectionWorldMarker;
}

export const DirectionMarkerSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    return (
        <S_DirectionMarkerSidebar className={props.className}>
            <MarkerTransportationSection marker={props.marker} />
            <MarkerCoordinatesSection
                coordinates={props.marker.elementData.coordinates}
                onCoordinatesChange={async (coordinates) => {
                    const { path, waypoints } = await getTransportPath(
                        props.marker.elementData.transport,
                        coordinates
                    );
                    ctxEdit.updateWorldMarkerData(props.marker.id, {
                        coordinates: waypoints,
                        path
                    });
                }}
            />
            <DirectionRouteMarkerStyleSection marker={props.marker} />
            <MarkerFloorSection marker={props.marker} />
            <MarkerControlsSection marker={props.marker} />
        </S_DirectionMarkerSidebar>
    );
};

const S_DirectionMarkerSidebar = styled.div``;
